<template>
  <div class="graduation">
    <GradCarousel v-if="showSwiper" />

    <div class="graduation__child">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import GradCarousel from "@/components/GradCarousel.vue";
export default {
  components: {
    GradCarousel,
  },
  computed: {
    showSwiper() {
      return this.$route.name !== "productIntro";
    },
  },
};
</script>

<style lang="scss">
.graduation {
  &__child {
    background-color: #2d2d2d;
    @media (min-width: 1440px) {
      margin-left: 120px;
    }
  }
}
</style>